import Table from 'react-bootstrap/Table';
import { Spinner } from 'react-bootstrap';
import moment from 'moment';
import PopOver from '../../../Components/PopOver/PopOver';
import {
  useDeleteVisitorEvent,
  useGetVisitorEventList,
} from '../apiEndpoints/VisitorApiEndpoints';

const RegisteredEvents = () => {
  const { mutate } = useDeleteVisitorEvent();
  const { data, isLoading } = useGetVisitorEventList();

  return (
    <div>
      <div className='profile-right-side px-3 py-3'>
        <h4 className='component-tittle'>Register Event</h4>

        <div className='profile-right-info pt-3 ps-2'>
          {isLoading ? (
            <div className='text-center mt-3'>
              <Spinner animation='border' variant='primary' />
            </div>
          ) : (
            <Table striped bordered hover>
              <thead>
                <tr className='text-center'>
                  <th>Date</th>
                  <th>Time Slot</th>
                  <th>Title</th>
                  <th>Venue</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {data?.data?.length ? (
                  <>
                    {data?.data?.map((sRegisterEvent) => {
                      return (
                        <tr
                          className='text-center'
                          key={sRegisterEvent.fair_event_id}
                        >
                          <td>
                            {moment(sRegisterEvent.event_date).format(
                              'MMM Do YY'
                            )}
                          </td>
                          <td>
                            {moment(
                              sRegisterEvent.event_start_time,
                              'HH:mm:ss'
                            ).format('LT')}{' '}
                            -{' '}
                            {moment(
                              sRegisterEvent.event_end_time,
                              'HH:mm:ss'
                            ).format('LT')}
                          </td>
                          <td>{sRegisterEvent.event_title}</td>
                          <td>{sRegisterEvent.event_venu}</td>
                          <td
                            style={{
                              verticalAlign: 'middle',
                            }}
                          >
                            <PopOver
                              confirm={() => {
                                mutate(sRegisterEvent?.fair_event_id);
                              }}
                              title='Are you sure to cancel this ?'
                            />
                          </td>
                        </tr>
                      );
                    })}
                  </>
                ) : (
                  <tr className='text-center'>
                    <td colSpan={5} className='fw-bold'>
                      No register event found!
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </div>
      </div>
    </div>
  );
};

export default RegisteredEvents;
